import { render } from "./ErrorsPage.vue?vue&type=template&id=3f44024c&scoped=true"
import script from "./ErrorsPage.vue?vue&type=script&lang=js"
export * from "./ErrorsPage.vue?vue&type=script&lang=js"

import "./ErrorsPage.vue?vue&type=style&index=0&id=3f44024c&scoped=true&lang=css"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f44024c"]])

export default __exports__